module.exports = __webpack_public_path__ + "success_icon.4bc99f37.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img/success_icon.svg
 ** module id = 965
 ** module chunks = 0
 **/